<template>
  <div>
    <v-layout
      row
      wrap
    >
      <v-flex
        v-if="!contact"
        sm12
        md3
        style="padding: 0 5px 0 5px;"
      >
        <v-card>
          <v-toolbar
            class="primary-color"
            dense
            flat
            dark
          >
            Search
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="searchText"
              :label="`Search ${pagination.totalItems} cases...`"
              solo
              append-icon="search"
              @keyup.enter="search()"
            />
            <v-select
              v-model="selectedField"
              :items="searchFields"
              solo
            />
            <v-select
              v-model="filterClosedCases"
              :items="[{'text': 'Open', 'value': true}, {'text': 'Closed', 'value': false}]"
              label="Case Status"
              hide-details
              solo
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="searchText='';tagSearch = '';filterTags=null;filterClosedCases=true;filterEnabled=null;search()"
            >
              Clear
            </v-btn>
            <v-btn
              color="primary"
              @click="search"
            >
              Search
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-flex>
      <div
        v-else
        style="display: flex;flex-direction: row;justify-content: space-between;width:100%;"
      >
        <v-select
          v-model="filterClosedCases"
          :items="[{'text': 'Open', 'value': true}, {'text': 'Closed', 'value': false}]"
          label="Case Status"
          hide-details
          style="margin-bottom: 10px;flex-grow: 0;" 
          dense
          @input="search()"
        />
        <slot></slot>
      </div>
      <v-flex
        sm12
        :md9="!contact"
        :md12="!!contact"
      >
        <v-card>
          <v-data-table
            :items="cases"
            :headers="headers"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :rows-per-page-items="paginationStrings"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td :colspan="!contact && !caseType ? 4 : 3">
                  <div
                    style="text-align:center;padding:25px;"
                  >
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                style="cursor: pointer;"
                @click="$router.push({name: 'ContactCaseView', params: { id: props.item.contact.id, case: props.item.id } })"
              >
                <td>
                  <v-icon>
                    {{ props.item.active ? 'mdi-briefcase' : 'mdi-briefcase-off-outline' }}
                  </v-icon>
                </td>
                <td
                  v-if="!caseType"
                >
                  {{ props.item.case_type.name }}
                </td>
                <td>
                  <div
                    style="font-size:16px;"
                  >
                    {{ props.item.case_number }} 
                  </div>
                  <i>{{ props.item.case_title }}</i>
                </td>
                <td
                  v-if="!contact"
                >
                  <ContactPreview
                    style="margin: 10px;"
                    :contact="props.item.contact"
                    :key="props.item.contact.id"
                  />
                </td>
              </tr>
            </template>
            <template slot="actions-append">
              <v-tooltip left>
                <span
                  slot="activator"
                >
                  <v-btn
                    round
                    flat
                    fab
                    small
                    @click="downloadCSV()"
                  >
                    <v-icon
                      color="green"
                    >
                      table_chart
                    </v-icon>
                  </v-btn>
                </span>
                <span>Download CSV<br /><small>Of Current Search Terms</small></span>
              </v-tooltip>
              <v-spacer />
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import pagination from '@/components/global/pagination'
import api from '@/api'
import ContactPreview from '../contacts/ContactPreview.vue'

const SEARCH_FIELDS = ['Any', 'Case Number', 'Case Title', 'Contact First Name', 'Contact Last Name']

export default {
    name: "CaseList",
    components: {
      ContactPreview
    },
    mixins: [
      pagination
    ],
    props: ['caseType', 'contact', 'softrouting'],
    data () {
      return {
        cases: [],
        pagination: {},
        searchText: '',
        loading: true,
        downloadingCSV: false,
        filter: {},
        filterClosedCases: true,
        paginationStrings: [
          10, 25, 50
        ],
        headers: [
          { text: 'Active', value: 'active', sortable: false, width: 75 }
        ],
        searchFields: SEARCH_FIELDS,
        selectedField: SEARCH_FIELDS[0]
      }
    },
    watch: {
      contact (){
        this.fetch()
      }
    },
    computed: {
      totalItems () {
        return this.pagination.totalItems
      }
    },
    created () {
      if (this.softrouting) {
        this.routing = false
      }
      if (!this.caseType)
        this.headers.push({
          text: 'Case Type', value: 'case_type', sortable: false
        })
      this.headers.push({ text: 'Case Number/Title', value: 'case_number' })
      if (!this.contact)
        this.headers.push({
          text: 'Contact', value: 'Contact', sortable: false
        })
    },
    methods: {
        fetch () {
          this.loading = true
          var filter = {...this.filter}
          if (this.caseType)
            filter['case_type'] = this.caseType
          if (this.contact)
            filter['contact'] = this.contact
          if (filter['active'] == undefined)
            filter['active'] = true
          api.cases.cases.list({
            search: this.searchText,
            ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy,
            pageNum: this.pagination.page,
            count: this.pagination.rowsPerPage,
            filter: filter,
            searchField: this.selectedField
          })
          .then((data) => {
            this.cases = data.results
            this.pagination.page = data.page_number
            this.pagination.totalItems = data.count
            this.loading = false
          })
          .finally(() => {
            this.componentCreated = true
          })
        },
        downloadCSV () {
          this.downloadingCSV = true
          api.cases.cases.downloadCSV({
            search: this.searchText,
            ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy,
            pageNum: this.pagination.page,
            count: this.pagination.rowsPerPage,
            filter: {...this.filter, case_type: this.caseType, contact: this.contact, active: this.filterClosedCases},
          })
            .then(response => {
              this.downloadingCSV = false
              let blob = new Blob([response.data])
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'Export_Cases.csv'
              link.click()
            })
        },
        search () {
          this.pagination.page = 1
          var queryParam = {}, filterQueryParam = {}
          if (this.searchText) {
            queryParam['search'] = this.searchText
            if (this.selectedField)
              queryParam['field'] = this.selectedField
          }
          if(filterQueryParam) {filterQueryParam= this.filter}
          filterQueryParam['active'] = this.filterClosedCases
          if (Object.keys(filterQueryParam).length !== 0) {queryParam['filter'] = JSON.stringify(filterQueryParam)}
          this.$router.push({ query: queryParam })
          this.fetch()
        },
    }
}
</script>

<style scoped>

.caseCard {
  position: relative;
  background: white;
  border: 1px solid #EEEEEE;
  padding: 7px;
  margin: 7px;
  border-radius: 5px;
  transition:background 0.4s, border 0.4s;
  cursor: pointer;
}

.caseCard:hover {
  background: #ECEFF1;  
  border: 1px solid #CFD8DC;
}

</style>